import { Alert } from '../components/atoms/alert';
import { isEUprod, isUSprod, isStaging, isTest, isUKprod } from './isNotProd';

export const gotoGrafana = (deviceId: string, fleetId: string, time = 'from=now-2d&to=now') => {
  let url = '';

  if (isUSprod()) {
    url = 'https://g-884b1b6a8d.grafana-workspace.us-west-2.amazonaws.com';
  } else if (isEUprod()) {
    url = 'https://g-58a3a90351.grafana-workspace.eu-central-1.amazonaws.com/d/kn_NMKl4d/fleet-health-dashboard-v2?orgId=1';
    url += `&${time}&var-server=${deviceId}&var-fleet_uuid=${fleetId}`;
    window.open(url);
    return;
  } else if (isUKprod()) {
    url = 'https://g-e8003ba016.grafana-workspace.eu-west-2.amazonaws.com/d/kn_NMKl4d/fleet-health-dashboard-v2?orgId=1';
    url += `&${time}&var-server=${deviceId}&var-fleet_uuid=${fleetId}`;
    window.open(url);
    return;
  } else if (isStaging()) {
    url = 'https://g-79729c31a8.grafana-workspace.us-west-2.amazonaws.com';
  } else if (isTest()) {
    url = 'https://g-b0567f44e0.grafana-workspace.us-west-2.amazonaws.com';
  }

  if (url) {
    window.open(`${url}/d/kn_NMKl4z/fleet-health-dashboard?orgId=1&${time}&var-server=${deviceId}&var-fleet_uuid=${fleetId}`);
    return;
  }

  new Alert('Grafana instance not configured for this environment.').alert();
};
